<ag-grid-angular
  style="width: 100%; height: 100%;"
  [initialState]="initialState"
  [theme]="tosTheme"
  [noRowsOverlayComponent]="CustomNoDataFound"
  [loading]="isLoading"
  [loadingOverlayComponent]="loadingOverlayComponent"
  [dataTypeDefinitions]="dataTypeDefinitions"
  [rowData]="tableRows"
  [columnDefs]="tableColumns"
  [rowSelection]="rowSelection"
  [enableFilterHandlers]="true"
  [selectionColumnDef]="selectionColumnDef"
  [defaultColDef]="defaultColDef"
  [stopEditingWhenCellsLoseFocus]="false"
  [invalidEditValueMode]="'block'"
  [domLayout]="domLayout"
  (stateUpdated)="saveGridState()"
  (gridReady)="onGridReady($event)"
  (selectionChanged)="onSelectionChanged()"
  (sortChanged)="handleSort($event)"
  (cellKeyDown)="onCellKeyDown($event)"
  (cellValueChanged)="onCellValueChanged($event)"
  (cellEditingStopped)="onCellEditingStopped($event)"
  (firstDataRendered)="onFirstDataRendered($event)"
/>
